module.exports = new __parcel__URL__("instagram.834d60d8.svg").toString();